import { adminApi } from "@/lib/api";

export const invApi = adminApi;

export const fmtQty = (n) => {
  const v = Number(n || 0);
  return Number.isInteger(v) ? String(v) : v.toFixed(2).replace(/\.?0+$/, "");
};

export const fmtWhen = (iso) =>
  iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";

export const LEDGER_LABEL = {
  intake: { text: "Intake", cls: "bg-emerald-100 text-emerald-800" },
  sale: { text: "Sale", cls: "bg-stone-100 text-stone-700" },
  square_sale: { text: "Square sale", cls: "bg-sky-100 text-sky-800" },
  sale_reversal: { text: "Cancelled order", cls: "bg-amber-100 text-amber-800" },
  adjustment: { text: "Adjustment", cls: "bg-violet-100 text-violet-800" },
  waste: { text: "Waste", cls: "bg-red-100 text-red-800" },
};
